define(["require", "exports", "tslib", "react"], function (require, exports, tslib_1, React) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.NotFoundView = void 0;
    React = tslib_1.__importStar(React);
    const style = {
        container: {
            display: "flex",
            flexDirection: "column",
            height: "100vh",
            overflowX: "hidden",
            overflowY: "scroll",
            padding: "10px",
            width: "100%"
        }
    };
    class NotFoundView extends React.Component {
        constructor(props) {
            super(props);
        }
        render() {
            return (React.createElement("div", { style: style.container }, "Not Implemented. Please contact support"));
        }
    }
    exports.NotFoundView = NotFoundView;
});
